import * as React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import '../styles/footer.scss'
import Year from './year'

export default function Footer() {
    const data = useStaticQuery(graphql`
        query FooterQuery {
            imbLogo: contentfulAsset(contentful_id: {eq: "6jI54Kga8umG4b6nFrPuhP"}) {
                file{
                    url
                }
            }
        }
    `)
    return (
        <>
            <Container id="footer" fluid className='topBorder' style={{ background: 'white' }}>
                <Row>
                    <Col xs={12} className='text-center mt-4 mt-lg-5'>
                        <Link to="/">
                            <img src={data.imbLogo.file.url} width={141} alt="" />
                        </Link>
                    </Col>
                </Row>
                
                <Row className='justify-content-center py-lg-3 py-3'>
                    <Col xs='auto' className='text-center'>
                        <Link to="/about">About</Link>
                    </Col>
                    <Col xs='auto' className='text-center'>
                        <Link to="/careers">Careers</Link>
                    </Col>
                    <Col xs='auto' className='text-center'>
                        <a href="https://support.inmusicstore.com/en/support/tickets/new" target='_blank' rel="noreferrer">Contact Us</a>
                    </Col>
                </Row>
            </Container>

            <Container fluid >
                <Row className=' justify-content-center text-center pt-4' style={{ background: 'white' }}>
                    <Col xs={'auto'}>
                        <p style={{ color: 'gray' }}>
                            © <Year /> inMusic Brands, Inc 200 Scenic View Drive, Cumberland, RI 02864 United States Tel: 401.658.3131 Fax: 401.658.3640
                        </p>
                        <p>
                            <Link to="/privacy-policy">Privacy Policy</Link>
                            <span style={{ color: 'gray' }}> · </span>
                            <Link to="/terms-of-use">Terms of Use</Link>
                            <span style={{ color: 'gray' }}> · </span>
                            <a href="https://cdn.inmusicbrands.com/inmusic/doc/UK_Modern_Slavery_Act_Statement.pdf" target='_blank' rel="noreferrer">Modern Slavery Act Transparency Statement</a>
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    )
}